import { phoneValidator as r } from "@propify-tenant-client/common";
import * as e from "yup";
const s = e.object().shape({
  firstName: e.string().required("Required"),
  lastName: e.string().required("Required"),
  email: e.string().email("Invalid Email").test(
    "is-email",
    "You must enter a valid email",
    function(t) {
      const { phone: i } = this.parent;
      return i ? !0 : t != null;
    }
  ),
  phone: e.string().test(
    "is-number",
    "Invalid Phone number",
    (n, t) => r(n, t.parent.countryCode)
  ).test("is-phone", "You must enter a valid phone number", function(t) {
    const { email: i } = this.parent;
    return i ? !0 : t != null;
  }),
  message: e.string().max(255)
}), o = e.object().shape({
  message: e.string().max(255)
});
export {
  s as validationSchema,
  o as validationSchemaIsLogged
};
//# sourceMappingURL=validations.js.map
